import React from "react";
import S from "./styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Submit = ({ name, icon }) => {
  return (
    <S.Container>
      <button type="submit">
        <div>
          <span>{name}</span>
          {icon && <FontAwesomeIcon icon={icon} size="lg" />}
        </div>
      </button>
    </S.Container>
  );
};
export default Submit;
